// extracted by mini-css-extract-plugin
module.exports = {"bbssao9":"bbssao9","pw60wn2":"pw60wn2"};